import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useDispatch, useSelector } from "react-redux";
import { generalConfigStore } from "@store";
import { store as choiceStore, setIsInlineErrorCleared } from "../../../store";
import { LANGUAGES, languages } from "@constants/index";
import { handleGetPaymentMethodsTagsButtonOnClickEvent } from "../../hooks";
import { store } from "@components/VerticalLayout/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { searchPosInArrayObject } from "../../../../../../helpers/general";
import { useFetchGlobal } from "../../../../../../api/hooks";

export const usePaymentMethodLogic = (props: any) => {
    const { t } = useTranslation();
    const { shopID, franchiseID, oneShop, shopPays, operatorID } = useSnapshot(
        store
    );
    const uuidUser = localStorage.getItem("uuidUser");
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const {
        shopsPaymentMethodsData,
        paymentMethodsData,
        isInlineErrorCleared,
        listFranchiseArchived,
        archivedModesInFranchise,
        dataArchive,
        isInputUpdated,
        isActionsClicked,
        isArchived,
    } = useSnapshot(choiceStore);
    const listOfCountry = useSelector((state: any) => state.global.pays);
    const dispatch = useDispatch();
    const { fetchGlobal } = useFetchGlobal();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const selectedLanguage = languages.find((el) => el.value === i18nextLng);
    const [isValidateButtonDisabled, setIsValidateButtonDisabled] = useState<
        boolean
    >(false);
    const [choiceMode, setChoiceMode] = useState<string>("");
    const [display, setDisplay] = useState<string>("");
    const [title, setTitle] = useState<string>("");
    const [identifier, setIdentifier] = useState<string>("");
    const [inputChoiceMode, setInputChoiceMode] = useState<boolean>(false);
    const [inputSaleSupport, setInputSaleSupport] = useState<boolean>(false);
    const [tags, setTags] = useState<any[]>([]);

    const [originPaymentMethodList, setOriginPaymentMethodList] = useState<
        any[]
    >([]);
    const [paymentMethodList, setPaymentMethodList] = useState<any[]>([]);
    const [isSendingTag, setIsSendingTag] = useState<boolean>(false);
    const [inputDisplay, setInputDisplay] = useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
    const [advancedDisplayName, setAdvancedDisplayName] = useState<any>({
        languages: LANGUAGES,
    });
    const [
        isAdvancedDisplayNameModalOpen,
        setIsAdvancedDisplayNameModalOpen,
    ] = useState(false);
    const [language, setLanguage] = useState<string[]>([]);
    const [countryList, setCountryList] = useState<any>([]);
    const [tagsData, setTagsData] = useState<any>([]);
    const [isMessageValidateClicked, setIsMessageValidateClicked] = useState<
        boolean
    >(false);
    const [isMessageModalOpened, setIsMessageModalOpened] = useState<boolean>(
        false
    );
    const [
        isArchivedFranchiseModalOpened,
        setIsArchivedFranchiseModalOpened,
    ] = useState<boolean>(false);

    const [idsAssociated, setIdsAssociated] = useState<any>([]);

    const [existingPaymentMethod, setExistingPaymentMethod] = useState<any>({});

    const [allAssociatedCountryShop, setAllAssociatedCountryShop] = useState<
        any
    >([]);

    const [
        isPaymentMethodAssociatedModified,
        setIsPaymentMethodAssociatedModified,
    ] = useState<boolean>(false);
    const [isNameExist, setIsNameExist] = useState(false);
    const [selectCountry, setSelectCountry] = useState<boolean>(false);
    const [countryData, setCountryData] = useState<any>([]);
    const [salesSupport, setSalesSupport] = useState<any>([]);
    const [salesSupportData, setSalesSupportData] = useState<any>([]);

    useEffect(() => {
        if (props.paymentMethod.id !== undefined) {
            setTitle(
                t(
                    props.isConsult
                        ? "View a payment method"
                        : "Modify a payment method"
                )
            );
            setIdentifier(props.paymentMethod.id);
            setTagsData(props.paymentMethod.Tag.split(","));
            setChoiceMode(props.paymentMethod[t("Type of payment method")]);
            setDisplay(props.paymentMethod[t("Display name")]);
            setSalesSupport(props.paymentMethod[t("Sales support")].split(","));
            setCountryData(props.paymentMethod["Country"].labels);
            setAdvancedDisplayName(props.paymentMethod.advancedDisplayName);
        } else {
            setChoiceMode("");
            setTitle(t("Add a payment method"));
            setDisplay("");
            setIdentifier("");
            setAdvancedDisplayName({
                languages: LANGUAGES,
            });
        }
    }, [
        props.paymentMethod,
        t,
        props.isAddNewChoiceButtonClicked,
        props.isConsult,
    ]);

    useEffect(() => {
        if (props.paymentMethod?.id === undefined) {
            setDisplay(choiceMode);
            setInputDisplay(false);
        }
    }, [props.paymentMethod?.id, choiceMode]);

    useEffect(() => {
        const fetchPaymentMethods = async () => {
            try {
                await handleGetPaymentMethodsTagsButtonOnClickEvent(
                    i18nextLng,
                    franchiseID,
                    shopID,
                    setTags,
                    setLanguage,
                    setSalesSupportData,
                    setOriginPaymentMethodList,
                    setPaymentMethodList,
                    listOfCountry,
                    dispatch,
                    fetchGlobal
                );
            } catch (error) {
                console.error("Failed to load payment methods", error);
            }
        };

        fetchPaymentMethods();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (oneShop) {
            let shopPaysItems =
                listOfCountry[
                    searchPosInArrayObject(listOfCountry, "label", shopPays)
                ];
            if (shopPaysItems !== undefined) {
                setCountryList([shopPaysItems.label]);
            }
        } else {
            setCountryList(listOfCountry);
        }
    }, [oneShop, listOfCountry, shopPays]);

    useEffect(() => {
        if (isInlineErrorCleared === true) {
            setInputChoiceMode(false);
            setInputDisplay(false);
            setSelectCountry(false);
            setInputSaleSupport(false);
            setIsInlineErrorCleared(false);
            clearData();
            clearMultiCustomSelectionData();
            setTagsData([]);
            setCountryData([]);
            setSalesSupport([]);
        }
    }, [isInlineErrorCleared, props.isAddChoiceClicked]);

    useEffect(() => {
        let allPaymentMethod: any = [];
        allPaymentMethod =
            paymentMethodsData !== undefined &&
            [...paymentMethodsData, ...dataArchive].map(
                (el: any) => `${el[t("Type of payment method")].toUpperCase()}`
            );

        if (props.paymentMethod.id !== undefined) {
            allPaymentMethod = allPaymentMethod.filter(
                (item: any) =>
                    item !==
                    `${props.paymentMethod[
                        t("Type of payment method")
                    ].toUpperCase()}`
            );
        }
        if (choiceMode !== "") {
            setIsNameExist(
                allPaymentMethod &&
                    allPaymentMethod
                        .map((el: any) => t(el).toUpperCase())
                        .includes(`${choiceMode.trim().toUpperCase()}`)
            );
        }
    }, [
        paymentMethodsData,
        choiceMode,
        t,
        props.paymentMethod,
        dataArchive,
        setIsNameExist,
    ]);

    useEffect(() => {
        if (advancedDisplayName.languages[i18nextLng] !== "") {
            setInputDisplay(false);
        }
        // eslint-disable-next-line
    }, [advancedDisplayName, i18nextLng]);

    useEffect(() => {
        let allPaymentShop: any = [];
        let allAssociatedCountryShop: any = [];
        if (shopsPaymentMethodsData !== undefined) {
            shopsPaymentMethodsData.forEach((el: any) => {
                if (el.subRows !== undefined) {
                    el.subRows.forEach((element: any) => {
                        allPaymentShop.push(element);
                        if (element.id === identifier) {
                            allAssociatedCountryShop.push(el.Country);
                        }
                    });
                }
                el.archivedPaymentMethods.forEach((elems: any) => {
                    if (elems.id === identifier) {
                        if (!allAssociatedCountryShop.includes(el.Country)) {
                            allAssociatedCountryShop.push(el.Country);
                        }
                    }
                });
            });
        }

        setAllAssociatedCountryShop([...new Set(allAssociatedCountryShop)]);
        setExistingPaymentMethod(
            allPaymentShop.find((el: any) => el.id === identifier)
        );
    }, [identifier, shopsPaymentMethodsData]);

    useEffect(() => {
        setInputChoiceMode(false);
        setInputDisplay(false);
        setSelectCountry(false);
        setInputSaleSupport(false);
        setIsInlineErrorCleared(false);
    }, [isInputUpdated, props.isEdited]);

    const mergedCountries = oneShop
        ? [...new Set([...countryData, ...countryList])]
        : [...new Set([...countryData, ...allAssociatedCountryShop])];

    const data = {
        [identifier]: {
            designation: choiceMode,
            display: display,
            shopId: [props.userData.shopId],
            saleSupport: salesSupport.join(","),
            country: mergedCountries.join(","),
            tag: tagsData.join(","),
            isActive:
                existingPaymentMethod !== undefined
                    ? existingPaymentMethod.isActive
                    : false,
            isArchived: false,
            advancedDisplayName: advancedDisplayName,
        },
    };
    const confirmationMessageText = !isArchived
        ? t(
              "The payment method already exists in the franchise. Do you want to associate it with this shop"
          )
        : t(
              "Attention! the sales method is already archived at the level of the franchise"
          );

    const resetData = () => {
        clearData();
        clearMultiCustomSelectionData();
        setTagsData([]);
        setCountryData([]);
        setSalesSupport([]);
        setTagsData([]);
        setCountryData([]);
        setSalesSupport([]);
    };

    return {
        t,
        choiceMode,
        setChoiceMode,
        display,
        setDisplay,
        advancedDisplayName,
        setAdvancedDisplayName,
        selectedLanguage,
        countryList,
        paymentMethodList,
        salesSupportData,
        tags,
        itemsDisable,
        title,
        identifier,
        tagsData,
        countryData,
        salesSupport,
        inputDisplay,
        language,
        setSalesSupport,
        setCountryData,
        setTagsData,
        setInputChoiceMode,
        inputChoiceMode,
        inputSaleSupport,
        setInputSaleSupport,
        originPaymentMethodList,
        setInputDisplay,
        setSelectCountry,
        selectCountry,
        setIsNameExist,
        isNameExist,
        existingPaymentMethod,
        allAssociatedCountryShop,
        i18nextLng,
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
        shopsPaymentMethodsData,
        setIdsAssociated,
        idsAssociated,
        isPaymentMethodAssociatedModified,
        setIsPaymentMethodAssociatedModified,
        setIsArchivedFranchiseModalOpened,
        isArchivedFranchiseModalOpened,
        setIsMessageModalOpened,
        isMessageModalOpened,
        setIsMessageValidateClicked,
        isMessageValidateClicked,
        setIsAdvancedDisplayNameModalOpen,
        isAdvancedDisplayNameModalOpen,
        setIsSendingTag,
        isSendingTag,
        setIsModalOpened,
        isModalOpened,
        listFranchiseArchived,
        archivedModesInFranchise,
        isActionsClicked,
        isArchived,
        data,
        confirmationMessageText,
        resetData,
        operatorID,
        uuidUser,
        oneShop,
        setCountryList,
    };
};
